import { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { DashboardString } from "../../../utils/string";
import APICallService from "../../../api/apiCallService";
import { dashBoardEndPoints } from "../../../api/apiEndPoints";
import Chart from "react-apexcharts";
import Loader from "../../../Global/loader";

const ClassStudent = () => {
  const [loading, setLoading] = useState(true);
  const [schoolDetails, setSchoolDetails] = useState<any>({
    classes: [],
    enrolledData: [],
  });

  useEffect(() => {
    (async () => {
      setLoading(true);
      await fetchClassWiseStudent();
      setLoading(false);
    })();
  }, []);

  const fetchClassWiseStudent = async () => {
    setLoading(true);
    const apiService = new APICallService(dashBoardEndPoints.CLASS_STUDENT);
    const response = await apiService.callAPI();
    if (response) {
      // const classes = response[0]?.classDetails?.map(
      //   (item: any) => item.className
      // );
      const classes = response[0]?.classDetails?.map((item: any) => {
        let schoolName = item.className;
        if (schoolName.length > 6) {
          schoolName = schoolName.substring(0, 5) + "...";
        }
        return schoolName;
      });
      const enrolledData = response[0]?.classDetails?.map(
        (item: any) => item.studentEnrolled
      );
      setSchoolDetails({
        classes,
        enrolledData,
      });
    }
    setLoading(false);
  };

  return (
    <Card className="mb-7 bg-f9f9f9">
      <Card.Header className="pt-4 border-bottom-0">
        <div className="card-title">
          <h2 className="fs-22 fw-bolder">
            {DashboardString.ClasswiseStudent}
          </h2>
        </div>
      </Card.Header>
      {!loading ? (
        schoolDetails.classes?.length > 0 ? (
          <Card.Body className="pb-0">
            <Chart
              options={{
                plotOptions: {
                  bar: {
                    horizontal: false,
                    columnWidth: "14%",
                    borderRadius: 3,
                  },
                },
                chart: {
                  fontFamily: "inherit",
                  type: "bar",
                  height: 350,
                  toolbar: {
                    show: false,
                  },
                  dropShadow: {
                    enabled: false,
                    color: "#1b74e4",
                    top: 0,
                    left: 0,
                    blur: 0,
                    opacity: 0.2,
                  },
                },
                dataLabels: {
                  enabled: false,
                },
                stroke: {
                  curve: "smooth",
                  show: true,
                  width: 1,
                  colors: ["#5795f7"], // switched colors order
                },
                legend: {
                  show: false,
                },
                xaxis: {
                  categories:
                    schoolDetails.classes.map((cls: any) => cls) || [],
                  axisBorder: {
                    show: false,
                  },
                  axisTicks: {
                    show: false,
                  },
                  labels: {
                    style: {
                      colors: "#231f20",
                      fontWeight: "500",
                      fontSize: "13px",
                    },
                  },
                },
                yaxis: {
                  labels: {
                    align: "center",
                    style: {
                      colors: "#231f20",
                      fontWeight: "500",
                      fontSize: "13px",
                    },
                    formatter: function (y) {
                      if (typeof y !== "undefined") {
                        return y.toFixed(0);
                      }
                      return y;
                    },
                  },
                },
                tooltip: {
                  enabled: true,
                  custom({ series, seriesIndex, dataPointIndex, w }) {
                    const enrolledCount = series[0][dataPointIndex];
                    return (
                      '<div class="card fs-15 p-3 ps-5 w-md-175px border-0 py-5">' +
                      "<div>" +
                      '<div class="fw-600">Enrolled Students</div>' +
                      "<div>" +
                      '<span class="d-inline-block w-10px h-10px rounded-circle me-3" style="background-color:#5795f7;"></span>' +
                      enrolledCount +
                      "</div>" +
                      "</div>" +
                      "</div>"
                    );
                  },
                },
                colors: ["#5795f7"], // switched colors order
                grid: {
                  borderColor: "#e0e0df",
                  strokeDashArray: 5,
                  yaxis: {
                    lines: {
                      show: true,
                    },
                  },
                },
                markers: {
                  size: 0,
                  colors: undefined,
                  strokeColors: "#1b74e4",
                  shape: "circle",
                  radius: 0,
                  hover: {
                    size: undefined,
                    sizeOffset: 3,
                  },
                },
              }}
              series={[
                {
                  name: "Enrolled", // switched order
                  data: schoolDetails.enrolledData || [], // switched order
                },
              ]}
              type="bar"
              height={350}
            />
            <div className="d-flex justify-content-center mb-7">
              <div className="d-flex align-items-center me-4">
                <span
                  className="d-inline-block w-15px h-15px rounded-circle me-2"
                  style={{ backgroundColor: "#5795f7" }}
                ></span>
                <span className="fw-bold fs-15">Enrolled students</span>
              </div>
            </div>
          </Card.Body>
        ) : (
          <Card.Body className="p-3">
            <div className="d-flex flex-center min-h-125px ">
              <span className="fs-18 fw-medium">No details available.</span>
            </div>
          </Card.Body>
        )
      ) : (
        <Card.Body className="min-h-200px">
          <div className="w-100 d-flex justify-content-center">
            <Loader loading={loading} />
          </div>
        </Card.Body>
      )}
    </Card>
  );
};

export default ClassStudent;
